import { render } from "./PhoneComponent.vue?vue&type=template&id=b4fd46a8&scoped=true"
import script from "./PhoneComponent.vue?vue&type=script&lang=js"
export * from "./PhoneComponent.vue?vue&type=script&lang=js"

import "./PhoneComponent.vue?vue&type=style&index=0&id=b4fd46a8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4fd46a8"]])

export default __exports__